export const UpgradeMessage = "ZK_7cb";
export default {UpgradeMessage};